import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, Box, CircularProgress, InputLabel, TextField, Typography, useTheme, Select, MenuItem, } from "@mui/material";
import SubHeader from "../../../../components/SubHeader";
import CommissonList from "./CommissonList";
import styles from "./style";
import Modal from "../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { CustomizedRadio } from "../../../../components/CustomRadio";

const CommissonPage = ({ data, getLeaveManagementLists, handleRequest, getApprovedCommission, handleLeaveApply, role, permission, handleFilter, handleSort, loading, employeeData, handleEmployee, open, setOpen, page, total, setPage, empData, DepartmentPayroll, departmentData, DeleteCommission, updateCommisson }) => {
  const theme = useTheme();
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [department, setDepartment] = useState();
  const [bonus, setBonus] = useState();
  const [commissionName, setCommissionName] = useState();
  const [empDataId, setEmpDataId] = useState(employeeData)
  const [fixed, setFixed] = useState("Fixed");
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [getId, setGetId] = useState(null)
  const [isEdit, setIsEdit] = useState(null)
  const [selectedOptions, setSelectedOptions] = useState(
    data?.employeeDetails || []
  );
  const [description, setDescription] = useState();
  const [isFormValid, setIsFormValid] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [commissionStatus, setCommissionStatus] = useState(null);
  const initialFormData = useRef(null);
  const [isEmailSelected, setIsEmailSelected] = useState(false);
  const [isDepartmentSelected, setIsDepartmentSelected] = useState(false);
  const isEmployeeRole = role === "Employee" || role === "employee";


  const radioLabel = [
    { label: "Fixed", value: "Fixed" },
  ];

  const handleEdit = (type, id) => {
    setIsEdit(type);
    setGetId(id);
    setOpen(true);
    if (type === "edit" && id) {
      const newCommissionName = id.name || "";
      const newBonus = id.rate || "";
      const newFromDate = id.start ? dayjs(id.start) : dayjs();
      const newToDate = id.end ? dayjs(id.end) : dayjs();
      const newFixed = id.rateType || "Fixed";
      const newDescription = id.desc || "";
      const newDepartment = id.department || "";
      // Ensure selectedOptions is always an array
      const newSelectedOptions = Array.isArray(id.employeeDetails)
        ? id.employeeDetails
        : id.employeeDetails && typeof id.employeeDetails === "object"
          ? [id.employeeDetails]
          : [];

      setCommissionName(newCommissionName);
      setBonus(newBonus);
      setFromDate(newFromDate);
      setToDate(newToDate);
      setFixed(newFixed);
      setDescription(newDescription);
      setDepartment(newDepartment);
      setSelectedOptions(newSelectedOptions);
      setCommissionStatus(id?.status || null);

      // Set initial form data for change detection
      initialFormData.current = {
        commissionName: newCommissionName,
        bonus: newBonus,
        fromDate: newFromDate,
        toDate: newToDate,
        fixed: newFixed,
        description: newDescription,
        department: newDepartment,
        selectedOptions: newSelectedOptions
      };
    }
  };

  useEffect(() => {
    if (isEdit === "edit" && initialFormData.current) {
      const changesDetected =
        String(commissionName || "") !== String(initialFormData.current.commissionName || "") ||
        String(bonus || "") !== String(initialFormData.current.bonus || "") ||
        (fromDate && initialFormData.current.fromDate
          ? !dayjs(fromDate).isSame(dayjs(initialFormData.current.fromDate), "day")
          : fromDate !== initialFormData.current.fromDate) ||
        (toDate && initialFormData.current.toDate
          ? !dayjs(toDate).isSame(dayjs(initialFormData.current.toDate), "day")
          : toDate !== initialFormData.current.toDate) ||
        String(fixed || "") !== String(initialFormData.current.fixed || "") ||
        String(description || "") !== String(initialFormData.current.description || "") ||
        String(department || "") !== String(initialFormData.current.department || "") ||
        JSON.stringify((selectedOptions || []).map(opt => opt._id || "")) !==
        JSON.stringify((initialFormData.current.selectedOptions || []).map(opt => opt._id || ""));

      setHasChanges(changesDetected);
    } else {
      setHasChanges(false);
    }
  }, [commissionName, bonus, fromDate, toDate, fixed, description, department, selectedOptions, isEdit]);

  // Add this useEffect to validate form in Add mode
  useEffect(() => {
    if (isEdit === "Add") {
      const hasEmailOrDepartment =
        (isEmailSelected && selectedOptions.length > 0) ||
        (isDepartmentSelected && !!department);
      const isValid =
        hasEmailOrDepartment &&
        !!commissionName &&
        !!bonus &&
        !!fromDate &&
        !!toDate &&
        !!fixed;
      setIsFormValid(isValid);
    }
  }, [selectedOptions, department, commissionName, bonus, fromDate, toDate, fixed, isEdit]);

  useEffect(() => {
    if (!open) {
      handleCloseModal();
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    const newValuesArray = Array.isArray(newValue) ? newValue : [newValue];

    const filteredNewValues = newValuesArray.filter(
      (newOption) =>
        newOption?._id &&
        !selectedOptions.some(
          (prevOption) => prevOption?._id === newOption?._id
        )
    );
    setSelectedOptions([...selectedOptions, ...filteredNewValues]);
  };

  const handleDepartmentChange = (e) => {
    const selectedDept = e.target.value;
    setDepartment(selectedDept);
    setIsDepartmentSelected(!!selectedDept)

    if (selectedDept === "All") {
      setSelectedOptions(empData);
    }
    else {
      DepartmentPayroll(selectedDept);
      const deptEmployees = empData.filter(
        (emp) => emp.personalInfo.department === selectedDept
      );
      const allSelected = Array.from(
        new Set([...deptEmployees, ...selectedOptions])
      );
      setSelectedOptions(allSelected);
    }
  };

  const handleCloseModal = () => {
    setCommissionName("");
    setBonus("");
    setFromDate(dayjs());
    setToDate(dayjs());
    setFixed("Fixed");
    setDescription("");
    setDepartment("");
    setSelectedOptions([]);
    setGetId(null);
    setIsEdit(null);
    setCommissionStatus(null);
    setHasChanges(false);
    setIsFormValid(false);
    initialFormData.current = null;
    setOpen(false);
  };

  useEffect(() => {
    if (open && isEdit === "Add") {
      setCommissionName("");
      setBonus("");
      setFromDate(dayjs());
      setToDate(dayjs());
      setFixed("Fixed");
      setDescription("");
      setDepartment("");
      setSelectedOptions([]);
    }
  }, [open, isEdit]);


  useEffect(() => {
    setEmpDataId((employeeData || []).filter(emp => !selectedOptions.some(sel => sel._id === emp._id)) || []);
  }, [employeeData, selectedOptions]);



  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.leaveHeading}>{isEmployeeRole ? "My Commission" : "Commission"}</Typography>
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title={isEmployeeRole ? "My Commission Requests" : "Commission Requests"}
          btn={permission?.commission?.isEdit || role === "Admin" || role === "SuperAdmin"}
          btn2={permission?.commission?.isEdit || role === "Admin" || role === "SuperAdmin"}
          search={permission?.commission?.isView || role === "Admin" || role === "SuperAdmin"}
          sortBy={permission?.commission?.isView || role === "Admin" || role === "SuperAdmin"}
          BtnText={"Add Request"}
          BtnText2={"Approve All"}
          onClick={() => {
            setOpen(true);
            setIsEdit("Add");
            setGetId(null);
            setDepartment("");
            setSelectedOptions([]);
            // Reset all form fields for Add mode
            setCommissionName("");
            setBonus("");
            setFromDate(dayjs());
            setToDate(dayjs());
            setFixed("Fixed");
            setDescription("");
            setIsDepartmentSelected(false);
            setIsEmailSelected(false);
          }}
          onClick2={() => getApprovedCommission()}
          onchange={handleFilter}
          handleSort={handleSort}
          onCompanyChange={getLeaveManagementLists}
        />
        <CommissonList data={data} setPage={setPage} page={page} total={total} permission={permission?.commission?.isEdit || role === "Admin" || role === "SuperAdmin"} DeleteCommission={DeleteCommission} setDeleteOpen={setDeleteOpen} setOpen={setOpen} deleteOpen={deleteOpen} handleEdit={handleEdit} />

        <Modal open={open} setOpen={setOpen} btnText={"Apply"} title={"Commission Request"} handleCheck={() => {
          (isEdit === "edit" ? updateCommisson(commissionName,
            bonus,
            dayjs(fromDate).format("YYYY-MM-DD"),
            dayjs(toDate).format("YYYY-MM-DD"),
            fixed,
            description,
            getId?._id) : handleLeaveApply(
              selectedOptions.map((option) => option._id),
              commissionName,
              bonus,
              dayjs(fromDate).format("YYYY-MM-DD"),
              dayjs(toDate).format("YYYY-MM-DD"),
              fixed,
              description

            ))
          handleCloseModal();
        }} loading={loading}
          approveTxt={isEdit === "edit" ? true : false}
          disabled={isEdit === "edit" ? !hasChanges : !isFormValid}
          handleRequest={(res) => handleRequest(getId?._id, res)}
          onClose={handleCloseModal}
          status={commissionStatus}
        >
          <Box sx={styles.containerInput}>
            <Box sx={styles.dateGrid}>
              <Box sx={{ mr: 1, width: "50%" }}>
                {permission?.attendance?.isEdit || role === "Admin" ?
                  <Autocomplete
                    id="autocomplete"
                    options={empDataId || []}
                    getOptionLabel={(option) => option?.personalInfo?.email}
                    onInputChange={(event, newInputValue) => {
                      handleEmployee(newInputValue);
                    }}

                    onChange={(event, newValue) => {
                      handleChange(event, newValue);
                      setIsEmailSelected(!!newValue);
                    }}
                    disabled={isDepartmentSelected}
                    renderInput={(params) => (
                      <><InputLabel sx={styles.label}>{"Employee Email"}</InputLabel>
                        <TextField
                          {...params}
                          sx={{
                            ...styles.modalInput, ...styles.inputSpace,
                            "& input::placeholder": {
                              color: "black", // Sets placeholder text color to black
                              opacity: 1,
                            },
                          }}
                          placeholder={getId?.employeeDetails?.personalInfo?.email || "Select Employee"}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }} /></>
                    )}
                  /> : null}
              </Box>
              <Box sx={{ width: "50%" }}>
                <InputLabel sx={styles.label}>Commission Name</InputLabel>
                <TextField
                  value={commissionName}
                  name="bonusName"
                  placeholder="Enter Commission Name"
                  onChange={(e) => {
                    setCommissionName(e.target.value);
                  }}
                  sx={styles.modalInputs}
                />
              </Box>
            </Box>
            <Box sx={styles.dateGrid}>
              <Box sx={{ width: "100%", mt: 1, mr: 1 }}>
                <InputLabel sx={styles.label}>Department</InputLabel>
                <Select
                  value={department}
                  onChange={handleDepartmentChange}
                  sx={{ ...styles.modalInput, borderRadius: "8px", my: "10px" }}
                  renderValue={(selected) => (selected ? selected : "Select Department")}
                  displayEmpty
                  disabled={isEmailSelected}
                >
                  <MenuItem disabled value="">
                    Select
                  </MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  {departmentData?.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item?.name}
                      onClick={() => DepartmentPayroll(item?.name)}
                    >
                      {item?.name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={{ width: "100%", mt: 1 }}>
                <InputLabel sx={styles.label}>{fixed === "Percentage" ? "Rate" : "Commission Amount"}</InputLabel>
                <TextField
                  value={bonus}
                  name="bonus"
                  placeholder="Enter Commission Amount"
                  onChange={(e) => {
                    const val = e.target.value;

                    const regex = /^[0-9]*$/;

                    if (regex.test(val)) {
                      const num = parseFloat(val);

                      if (!isNaN(num) && num > 0) {
                        setBonus(val);
                      } else if (val === "") {
                        setBonus("");
                      }
                    }
                  }}
                  sx={styles.modalInputs}
                />

              </Box>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={styles.calender}>
                <Box styles={styles.calenderW}>
                  <InputLabel sx={styles.label}>Start</InputLabel>
                  <DatePicker value={fromDate}
                    onChange={(newValue) => { setFromDate(newValue) }}
                    sx={styles.calenderInput} slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                  />
                </Box>
                <Box styles={styles.calenderW}>
                  <InputLabel sx={styles.label}>End</InputLabel>
                  <DatePicker
                    value={toDate}
                    minDate={fromDate}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }}
                    sx={{ ...styles.calenderInput }}
                    onChange={(newValue) => { setToDate(newValue); }}
                  />
                </Box>
              </Box>
            </LocalizationProvider>

            <Box sx={{ my: 2 }}>
              <InputLabel sx={styles.label}>Description</InputLabel>
              <TextField
                multiline={true}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={2}
                sx={styles.reason}
              />
            </Box>

            <Box sx={{ mt: 5 }}>
              <Box
                onClick={() => {
                  setFixed(fixed === "Fixed" ? "" : "Fixed");
                }}
                sx={{
                  cursor: 'pointer',
                  '& .MuiFormControlLabel-root': {
                    pointerEvents: 'none'
                  }
                }}
              >
                <CustomizedRadio
                  handleChange={(val) => setFixed(val)}
                  value={fixed}
                  radioLabel={radioLabel}
                />
              </Box>
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default CommissonPage;
